import * as React from "react";
import { getMonthYearName, getLocalizedText } from "../util";
import { LazyLoadImage } from "react-lazy-load-image-component";
import images from "url:../../images/*.jpg";
import gifs from "url:../../images/*.gif";
import "../../css/opacity.css";
import { creationData } from "../data";
import { getAssetUrl, mergeAssetMaps, resolveAssetMap } from "../asset";
import { useLang } from "../lang";
import { useReadMore } from "../hooks/useReadMore";

const Creation: React.FC = () => {
  const { langEn } = useLang();
  const { expanded, toggle, isVisible } = useReadMore(5);
  const imageMap = mergeAssetMaps(resolveAssetMap(images), resolveAssetMap(gifs));
  const renderImage = (imageKey?: string, alt?: string) => {
    const imageUrl = getAssetUrl(imageMap, imageKey);
    return imageUrl ? (
      <LazyLoadImage
        src={imageUrl}
        alt={alt ?? ""}
        effect="opacity"
        className="bd-placeholder-img img-fluid w-100"
      />
    ) : (
      ""
    );
  };

  return (
    <div id="creation" className="container justify-content-center">
      <p className="title">{langEn ? "Non Research Projects" : "研究外のプロジェクト"}</p>
      <div className="row mt-3">
        <div className="col-md-12 mb-4">
          {creationData
            .filter((item, i) => isVisible(i))
            .map((item, i) => (
              <div className="card mb-2 paper" key={i}>
                <div className="row no-gutters">
                  <div className="col-md-3">
                    {renderImage(item.img, getLocalizedText(item.title, langEn))}
                  </div>

                  <div className="col-md-9">
                    <div className="card-body pt-2 pb-1">
                      <p className="card-title mb-1 h6">
                        {getLocalizedText(item.title, langEn)}
                        <small className="ml-2">
                          ({getMonthYearName(item.month, item.year, langEn)})
                        </small>
                      </p>

                      <p className="card-text mb-1 small">
                        {getLocalizedText(item.description, langEn)}
                      </p>

                      <ul className="links mt-0 small">
                        {(item.links ?? []).map((link, i) => (
                          <li key={i}>
                            <span>{getLocalizedText(link.title, langEn)}</span>
                            <a
                              href={getLocalizedText(link.url, langEn)}
                              className="ml-1 icon-link"
                              aria-label={getLocalizedText(link.title, langEn)}
                            ></a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {!expanded ? (
            <a
              href=""
              className=""
              onClick={(e) => {
                e.preventDefault();
                toggle();
              }}
            >
              more &raquo;
            </a>
          ) : (
            ""
          )}
          {expanded ? (
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                toggle();
              }}
            >
              &laquo; close
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Creation;
